import { useWeb3React } from '@web3-react/core'
import { useQueryClient } from 'react-query'
import { QueryKey } from 'config/constants/queryKey'
import { useCallback } from 'react'

const useInvalidateBoostedFarms = () => {
  const queryClient = useQueryClient()
  const { account } = useWeb3React()

  const invalidatingBoostedFarms = useCallback(() => {
    queryClient.invalidateQueries([QueryKey.GET_BOOSTED_FARMS, account])
  }, [account, queryClient])

  return { onInvalidatingBoostedFarms: invalidatingBoostedFarms }
}

export default useInvalidateBoostedFarms
